/**
 * @desc 修改月分计划
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanMonthCommonUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/month/updatePartPlan',
    data,
  });
}

export function mock(
  data: defs.PlanMonthCommonUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/month/updatePartPlan',
    data,
  });
}
